import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

type Palette = {
	background: {
		default: string;
		active: string;
		hover: string;
	};
	color: {
		active: string;
	};
};

export const makePalette = (
	bgcolor: string,
	activeBgcolor: string,
	activeColor: string,
): Palette => ({
	background: {
		default: bgcolor,
		active: activeBgcolor,
		hover: activeBgcolor,
	},
	color: {
		active: activeColor,
	},
});

/**
 * The colors match import { colourPickerPalette } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/colours';
 * But dont want to import that file, in the BE it becomes a string anyway
 */
export const scenarioTheme: { [key: string]: Palette } = {
	// Light Yellow
	[colors.Y100]: makePalette(
		token('color.background.accent.yellow.subtlest'),
		token('color.background.accent.yellow.subtler'),
		token('color.background.accent.yellow.bolder'),
	),
	// Orange
	[colors.Y400]: makePalette(
		token('color.background.accent.orange.subtlest'),
		token('color.background.accent.orange.subtler'),
		token('color.background.accent.orange.bolder'),
	),
	// Light teal
	[colors.T100]: makePalette(
		token('color.background.accent.teal.subtlest'),
		token('color.background.accent.teal.subtler'),
		token('color.background.accent.teal.bolder'),
	),
	// Teal
	[colors.T400]: makePalette(
		token('color.background.accent.teal.subtlest'),
		token('color.background.accent.teal.subtler'),
		token('color.background.accent.teal.bolder'),
	),
	// Light purple
	[colors.P75]: makePalette(
		token('color.background.accent.purple.subtlest'),
		token('color.background.accent.purple.subtler'),
		token('color.background.accent.purple.bolder'),
	),
	// Purple
	[colors.P400]: makePalette(
		token('color.background.accent.purple.subtlest'),
		token('color.background.accent.purple.subtler'),
		token('color.background.accent.purple.bolder'),
	),
	// Light blue
	[colors.B100]: makePalette(
		token('color.background.accent.blue.subtlest'),
		token('color.background.accent.blue.subtler'),
		token('color.background.accent.blue.bolder'),
	),
	// Blue
	[colors.B400]: makePalette(
		token('color.background.accent.blue.subtlest'),
		token('color.background.accent.blue.subtler'),
		token('color.background.accent.blue.bolder'),
	),
	// Light green
	[colors.G100]: makePalette(
		token('color.background.accent.green.subtlest'),
		token('color.background.accent.green.subtler'),
		token('color.background.accent.green.bolder'),
	),
	// Green
	[colors.G400]: makePalette(
		token('color.background.accent.green.subtlest'),
		token('color.background.accent.green.subtler'),
		token('color.background.accent.green.bolder'),
	),
	// Light red
	[colors.R100]: makePalette(
		token('color.background.accent.red.subtlest'),
		token('color.background.accent.red.subtler'),
		token('color.background.accent.red.bolder'),
	),
	// Red
	[colors.R400]: makePalette(
		token('color.background.accent.red.subtlest'),
		token('color.background.accent.red.subtler'),
		token('color.background.accent.red.bolder'),
	),
	// Fallback for when nothing matches
	default: makePalette(
		token('color.background.accent.gray.subtlest'),
		token('color.background.accent.gray.subtler'),
		token('color.background.neutral.subtle.pressed'),
	),
};

type Color = ReturnType<typeof token>;

export type ColorPalette = {
	light: Color;
	medium: Color;
	dark: Color;
};
